import styled from 'styled-components';
import { flex } from '@/styles/layout';

export const PageColumnWrapper = styled.div`
  ${flex({ flexDirection: 'column' })};
  flex: 1;
  row-gap: 28px;
  min-width: 0;
`;
